import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Customers from "./scenes/customers";
import Employees from "./scenes/employees";
import Suppliers from "./scenes/suppliers";
import Ingredients from "./scenes/ingredients";
import Recipes from "./scenes/recipes";
import Products from "./scenes/products";
import FermentationTanks from "./scenes/fermentationtanks";
import ProductionBatches from "./scenes/productionbatches";
import StorageLocations from "./scenes/storagelocations";
import CustomerRelationshipManagement from "./scenes/customerrelationshipmanagement";
import CustomerRelationshipManagementByStatus from "./scenes/customerrelationshipmanagement/indexByStatus";
import CustomerRelationshipManagementByContactMethod from "./scenes/customerrelationshipmanagement/indexByContactMethod";
import FleetManagement from "./scenes/fleetmanagement";
import SalesOrderManagement from "./scenes/salesordermanagement";
import SalesOrderManagementByStatus from "./scenes/salesordermanagement/indexByStatus";
import SalesOrderManagementByPaymentStatus from "./scenes/salesordermanagement/indexByPaymentStatus";
import CaskContainerTracking from "./scenes/caskcontainertracking";
import CaskContainerTrackingByStatus from "./scenes/caskcontainertracking/indexByStatus";
import CaskContainerTrackingByContainerType from "./scenes/caskcontainertracking/indexByContainerType";
import QualityControl from "./scenes/qualitycontrol";
import Inventory from "./scenes/inventory";
import InventoryByStatus from "./scenes/inventory/indexByStatus";
import InventoryByUnit from "./scenes/inventory/indexByUnit";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/customers" element={<ProtectedRoute element={<Customers searchTerm={searchTerm} />} />} />
<Route path="/employees" element={<ProtectedRoute element={<Employees searchTerm={searchTerm} />} />} />
<Route path="/suppliers" element={<ProtectedRoute element={<Suppliers searchTerm={searchTerm} />} />} />
<Route path="/ingredients" element={<ProtectedRoute element={<Ingredients searchTerm={searchTerm} />} />} />
<Route path="/recipes" element={<ProtectedRoute element={<Recipes searchTerm={searchTerm} />} />} />
<Route path="/products" element={<ProtectedRoute element={<Products searchTerm={searchTerm} />} />} />
<Route path="/fermentationtanks" element={<ProtectedRoute element={<FermentationTanks searchTerm={searchTerm} />} />} />
<Route path="/productionbatches" element={<ProtectedRoute element={<ProductionBatches searchTerm={searchTerm} />} />} />
<Route path="/storagelocations" element={<ProtectedRoute element={<StorageLocations searchTerm={searchTerm} />} />} />
<Route path="/customerrelationshipmanagement" element={<ProtectedRoute element={<CustomerRelationshipManagement searchTerm={searchTerm} />} />} />
<Route path="/customerrelationshipmanagement/list" element={<ProtectedRoute element={<CustomerRelationshipManagement searchTerm={searchTerm} />} />} />
<Route path="/customerrelationshipmanagement/status" element={<ProtectedRoute element={<CustomerRelationshipManagementByStatus searchTerm={searchTerm} />} />} />
<Route path="/customerrelationshipmanagement/contactmethod" element={<ProtectedRoute element={<CustomerRelationshipManagementByContactMethod searchTerm={searchTerm} />} />} />
<Route path="/fleetmanagement" element={<ProtectedRoute element={<FleetManagement searchTerm={searchTerm} />} />} />
<Route path="/fleetmanagement/list" element={<ProtectedRoute element={<FleetManagement searchTerm={searchTerm} />} />} />
<Route path="/salesordermanagement" element={<ProtectedRoute element={<SalesOrderManagement searchTerm={searchTerm} />} />} />
<Route path="/salesordermanagement/list" element={<ProtectedRoute element={<SalesOrderManagement searchTerm={searchTerm} />} />} />
<Route path="/salesordermanagement/status" element={<ProtectedRoute element={<SalesOrderManagementByStatus searchTerm={searchTerm} />} />} />
<Route path="/salesordermanagement/paymentstatus" element={<ProtectedRoute element={<SalesOrderManagementByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/caskcontainertracking" element={<ProtectedRoute element={<CaskContainerTracking searchTerm={searchTerm} />} />} />
<Route path="/caskcontainertracking/list" element={<ProtectedRoute element={<CaskContainerTracking searchTerm={searchTerm} />} />} />
<Route path="/caskcontainertracking/status" element={<ProtectedRoute element={<CaskContainerTrackingByStatus searchTerm={searchTerm} />} />} />
<Route path="/caskcontainertracking/containertype" element={<ProtectedRoute element={<CaskContainerTrackingByContainerType searchTerm={searchTerm} />} />} />
<Route path="/qualitycontrol" element={<ProtectedRoute element={<QualityControl searchTerm={searchTerm} />} />} />
<Route path="/qualitycontrol/list" element={<ProtectedRoute element={<QualityControl searchTerm={searchTerm} />} />} />
<Route path="/inventory" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/list" element={<ProtectedRoute element={<Inventory searchTerm={searchTerm} />} />} />
<Route path="/inventory/status" element={<ProtectedRoute element={<InventoryByStatus searchTerm={searchTerm} />} />} />
<Route path="/inventory/unit" element={<ProtectedRoute element={<InventoryByUnit searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
